import React from 'react';
import { LoadingOverlay } from "../../../../ab-common-legacy/LoadingOverlay";
import { Keys, defaultPinnedCountries, placeholders } from "../../Common/Constants";
import { SearchComponentV2 } from "../../Common/SearchComponentV2";
var NationalityQuestionContent = function NationalityQuestionContent(props) {
  var nationality = props.nationality,
    setField = props.setField,
    countriesData = props.countriesData,
    errorMessage = props.errorMessage,
    isLoading = props.isLoading,
    setErrorMessage = props.setErrorMessage;
  var clearError = function clearError() {
    setErrorMessage('');
  };
  if (isLoading) {
    return /*#__PURE__*/React.createElement(LoadingOverlay, {
      "aria-label": "Loading"
    });
  }
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(SearchComponentV2, {
    keyName: Keys.Application.nationality,
    clearError: clearError,
    errorMessage: errorMessage,
    items: countriesData,
    pinnedItems: defaultPinnedCountries,
    placeholder: placeholders.country,
    field: nationality,
    setField: setField
  }));
};
export default NationalityQuestionContent;